import { useRef } from "react";
import { ComponentWithViewTracking } from "../../helpers/analytics.mjs";
import { Box } from "../Box/index.mjs";
import { jsx } from "react/jsx-runtime";
const TrackableContainer = ({
  analyticsName,
  trackImpression,
  eventName,
  ...props
}) => {
  const ref = useRef(null),
    Component = /* @__PURE__ */jsx(Box, {
      ref,
      ...props
    });
  return analyticsName && trackImpression ? /* @__PURE__ */jsx(ComponentWithViewTracking, {
    Component,
    analyticsName,
    eventName,
    ref
  }) : Component;
};
export { TrackableContainer };